// extracted by mini-css-extract-plugin
export default {"container":"PaymentInfoItem_container__-J0h5"};